import {
	type SecuritySettingsResponse,
	type SecuritySettings,
	type GlobalAccessTypeEnum,
	type ShareRequestsAccessEnum,
	ACCESS_TYPES,
	PORTAL_ACCESS,
	SHARE_REQUESTS_ACCESS,
} from '../../types';

const getGlobalAccessType = (source: SecuritySettingsResponse): GlobalAccessTypeEnum => {
	const { globalAnonymousAccess, globalPublicSignup } = source;
	if (globalAnonymousAccess && globalPublicSignup) {
		return ACCESS_TYPES.ANONYMOUS;
	}

	if (globalPublicSignup) {
		return ACCESS_TYPES.PUBLIC;
	}
	return ACCESS_TYPES.INTERNAL;
};

const shareRequestsAccess = (source: SecuritySettingsResponse): ShareRequestsAccessEnum => {
	const { autocompleteEnabled, manageEnabled } = source;
	if (autocompleteEnabled && manageEnabled) {
		return SHARE_REQUESTS_ACCESS.SEARCH_AUTO_COMPLETE;
	}

	if (manageEnabled) {
		return SHARE_REQUESTS_ACCESS.EMAIL_ONLY;
	}
	return SHARE_REQUESTS_ACCESS.AGENT_ONLY;
};

export const transformSource = (source: SecuritySettingsResponse): SecuritySettings => {
	const {
		projectName,
		portalId,
		portalUrl,
		emailAddress,
		serviceDeskOpenAccess,
		serviceDeskPublicSignup,
	} = source;

	const globalAccessType = getGlobalAccessType(source);

	return {
		projectName,
		portalId,
		portalUrl,
		serviceDeskEmail: emailAddress,
		globalAccessType,
		portalAccess:
			!serviceDeskOpenAccess && !serviceDeskPublicSignup
				? PORTAL_ACCESS.RESTRICTED
				: globalAccessType,
		shareRequestsAccess: shareRequestsAccess(source),
	};
};
